import { Autocomplete, Box, Button, Card, CardContent, CardHeader, Chip, Stack, TextField, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../stores/hooks";
import { useEffect, useState } from "react";
import { DropdownModel, NLCInfo, OutputTableInfo } from "../../data/interfaces/sharedmodels";
import { updateBuildTableStep as updateMagneticBuildTableStep, updateselectedoutputtables as updateMagneticSelectedoutputtables,
    updateCurrentJobNumber as updateMagneticCurrentJobNumber,updateJobDescription as  updateMagneticJobDescription} from "../../stores/magneticslice";
import { updateBuildTableStep as updateItsoBuildTableStep, updateselectedoutputtables as updateItsoSelectedoutputtables,
    updateCurrentJobNumber as updateItsoCurrentJobNumber,updateJobDescription as  updateItsoJobDescription } from "../../stores/itsoslice";
import { Job, JobTask, OutputFolder } from "../../data/interfaces/tablegenmodels";
import magneticService from "../../data/api/magnetic.service";
import jobService from "../../data/api/job.service";
import { Warning } from "@mui/icons-material";
import { showwarningmessage } from "../../stores/notificationslice";
const BuildSettingsHeader = ({ parent }: { parent: string }) => {
    
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="h6">Confirm Build Settings</Typography>
            
        </Box>
    )
}


export default function BuildSettings({ parent }: { parent: string }) {

    const dispatch = useAppDispatch();
    const [error, setError] = useState(true);
    const [description, setDescription] = useState('');
    //const [outputFolders, setOutpuFolders] = useState<OutputFolder[]>([]);

    const selectedOutputTables = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedOutputTables; }
        else { return state.itsoReducer.selectedOutputTables; }
    });

    const jobDescription = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.jobDescription; }
        else { return state.itsoReducer.jobDescription; }
    });
    const selectedOutputNlcs = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedOutputNlcs; }
        else { return state.itsoReducer.selectedOutputNlcs; }
    });

    const handleGoBack = () => {
        if (parent === 'magnetic') {
            dispatch(updateMagneticBuildTableStep(0));
        }
        else {
            dispatch(updateItsoBuildTableStep(0));
        }
    }

    const handleDelete = (table: OutputTableInfo) => () => {
        const currentIndex = selectedOutputTables.findIndex(a => a.Id == table.Id);
        const newChecked = [...selectedOutputTables];

        if (currentIndex > -1) {
            newChecked.splice(currentIndex, 1);
        }
        if (parent === 'magnetic') {
            dispatch(updateMagneticSelectedoutputtables(newChecked));
        }
        else {
            dispatch(updateItsoSelectedoutputtables(newChecked));
        }
    };

    const handleDescription=(description:string)=>{
        setDescription(description);
        if (parent === 'magnetic') {
            dispatch(updateMagneticJobDescription(description));
        }
        else {
            dispatch(updateItsoJobDescription(description));
        }
        setError(description.length < 5);
    }

    const handleBuild = () => {
        if (description == null || description.length < 5) {
            setError(true);
            dispatch(showwarningmessage("Description must be at least 5 characters long"));
           return;
        }
        else{
            setError(false);
          
        }
        let tasks = [] as JobTask[];
        selectedOutputTables.forEach(table => {
            if (table.IsGlobal) {
                tasks.push({
                    Id: undefined,
                    TableId: table.Id,
                    Table: undefined,
                    TableInfo: undefined,
                    NlcId: null,
                    NlcInfo: undefined,
                    CompletionDate: null,
                    Status: null
                } as JobTask);
            }
            else {
                selectedOutputNlcs.forEach(nlc => {
                    tasks.push({
                        Id: undefined,
                        TableId: table.Id,
                        Table: undefined,
                        TableInfo: undefined,
                        NlcId: nlc.Id,
                        NlcInfo: undefined,
                        CompletionDate: null,
                        Status: null
                    } as JobTask);
                })
            }
        });
        let job = {
            Id: undefined,
            TocId: undefined,
            TicketTypeId:parent=="magnetic"?1:2,
            Toc: undefined,
            JobNumber: undefined,
            Description: jobDescription,
            OutputFolderPath: undefined,
            CreatedDate: undefined,
            CompletionDate: null,
            CreatedUser: undefined,
            JobTasks: tasks
        } as Job;

        magneticService.initiateBuildJob(job).then((response)=>{
            jobService.startJobs();
            if (parent === 'magnetic') {
                dispatch(updateMagneticCurrentJobNumber(response.data));
                dispatch(updateMagneticBuildTableStep(2));
            }
            else {
                dispatch(updateItsoCurrentJobNumber(response.data));
                dispatch(updateItsoBuildTableStep(2));
            }
        });
    }
    return (
        <Box>
            <Card>
                <CardHeader title={<BuildSettingsHeader parent={parent} />}></CardHeader>
                <CardContent>
                <Stack spacing={2}>
                    {selectedOutputTables.findIndex(a => a.IsGlobal) > -1 ? 
                        <Box>
                            Global Tables :
                            {selectedOutputTables.filter(a => a.IsGlobal).map((table: OutputTableInfo) => {
                                return (
                                    <Chip key={table.Id} label={table.Name + ' - ' + table.Description} variant="outlined"
                                        sx={{ m: 0.5, borderColor: 'primary.main', color: 'primary.main' }} onDelete={handleDelete(table)} />
                                )
                            })

                            }
                        </Box>: null}
                    
                    {selectedOutputTables.findIndex(a => !a.IsGlobal) > -1 ? <Box>
                        <Box>
                            Station Specific Tables :
                            {selectedOutputTables.filter(a => !a.IsGlobal).map((table: OutputTableInfo) => {
                                return (
                                    <Chip key={table.Id} label={table.Name + ' - ' + table.Description} variant="outlined"
                                        onDelete={handleDelete(table)} sx={{ m: 0.5, borderColor: 'primary.main', color: 'primary.main' }} />
                                )
                            })

                            }
                        </Box>
                        <Box sx={{mt:2}}>
                            Stations :
                            {selectedOutputNlcs.map((nlc: NLCInfo) => {
                                return (
                                    <Chip key={nlc.Id} label={nlc.NLC + ' - ' + nlc.StationName}
                                        sx={{ m: 0.5, backgroundColor: '#efefef', color: 'primary.main' }} />
                                )
                            })

                            }
                        </Box>
                        </Box>:null}
                        <Box >
                            <TextField multiline={true}  minRows={2} sx={{minWidth:300}} required={true} label="Description" inputProps={{maxLength:50}} onChange={(event)=>handleDescription(event.target.value)} error={error}
      helperText={error ? 'Description must be at least 5 characters long' : ''}/>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <Button variant="outlined" onClick={handleGoBack} sx={{mr:2}}>Back</Button>
                            <Button variant="contained" onClick={handleBuild}>Confirm & Build</Button>
                        </Box>
                    </Stack>
                        
                </CardContent>
            </Card>
        </Box>
    )
}